import React, { Component } from 'react'
import { connect } from 'react-redux'
import queryString from 'query-string'
import { fetchQuoteDetails } from './actions/quote'
import { fetchBrandDetails } from './actions/brands'
import { fetchLabelsData } from './actions/labelsData'
import EQuoteHeader from './components/structure/EQuoteHeader'
import EQuotePreviewPackageContent from './components/structure/EQuotePreviewPackageContent'
import EQuoteRequestMoreDetailsContent from './components/structure/EQuoteRequestMoreDetailsContent'
import './styles/scss/base/base.scss'
import './styles/scss/base/utilities.scss'
import './styles/scss/base/typography.scss'
import './styles/scss/base/buttons.scss'
import './styles/scss/base/tables.scss'
import './styles/scss/base/sliders.scss'
import './styles/scss/base/modal.scss'
import './styles/scss/base/print.scss'
import EQuotePreviewPackageFooter from './components/structure/EQuotePreviewPackageFooter'
import brandLoader from './assets/icons/brand-loader-final.gif'
import { getBrandClassName } from './reducers/packageDetails'
import { updateCurrentAppStep } from './actions/appState'
import FormSubmissionConfirmation from './components/FormSubmissionConfirmation/FormSubmissionConfirmation'
import ErrorPage from './components/ErrorPage/ErrorPage'
import triggerCustomGaEvent from './utils/triggerCustomGaEvent'
import { quoteDetailsError } from './actions/quote'

class App extends Component {
  componentDidMount() {
    const id = queryString.parse(window.location.search).id

    if (!id || id === '404') {
      this.props.handle404()
      triggerCustomGaEvent('equoteTracking-landingPage', {
        landingPage: '404'
      })
    } else {
      this.props.fetchQuoteDetails(id)
      this.props.fetchBrandDetails()
    }
    this.props.fetchLabelsData()
    const rfp = queryString.parse(window.location.search).rfp

    if (rfp) {
      triggerCustomGaEvent('equoteTracking-landingPage', {
        landingPage: 'rfpForm'
      })
      //  go straight to step two,
      this.props.moveToRFPForm()
    }
    triggerCustomGaEvent('equoteTracking-landingPage', {
      landingPage: 'quote preview'
    })
  }

  getMainClassForThePage = () => {
    switch (this.props.currentStep) {
      case 0:
        return 'equote_preview-package-content'
      case 1:
        return 'equote_request-more-details-content'
      case 2:
        return 'equote_form-submission-confirmation'
      default:
        return 'equote_preview-package-content'
    }
  }

  renderComponents() {
    if (this.props.hasErrors) {
      return (
        <ErrorPage
          errorStatus={this.props.errorStatus}
          labelsErrorDetails={this.props.labelsErrorDetails}
        />
      )
    }
    switch (this.props.currentStep) {
      case 0:
        return <EQuotePreviewPackageContent />
      case 1:
        return <EQuoteRequestMoreDetailsContent />
      case 2:
        return <FormSubmissionConfirmation />
      default:
        return <EQuotePreviewPackageContent />
    }
  }
  render() {
    const { isLoading, brandClassName, errorStatus } = this.props

    return (
      <div
        className={`app-container ${brandClassName} ${
          errorStatus ? 'app-container-with-error' : ''
        } ${isLoading ? 'loading' : ''}`}
      >
        <EQuoteHeader errorStatus={errorStatus} />
        {isLoading ? (
          <div
            className="u-loading-spinner"
            style={{
              flex: 1
            }}
          >
            <img src={brandLoader} alt="loading..." />
          </div>
        ) : (
          <div className={`${this.getMainClassForThePage()}`}>
            {this.renderComponents()}
          </div>
        )}
        <EQuotePreviewPackageFooter />
      </div>
    )
  }
}

const mapStateToProps = state => {
  const labelsErrorDetails = {
    404: state.labelsData.labels ? state.labelsData.labels['error-404'] : null,
    500: state.labelsData.labels ? state.labelsData.labels['error-500'] : null,
    loading: state.labelsData.isLoading,
    deprecated: {
      title: `we're sorry.`,
      body: `We’re sorry, the Azamara brand is no longer supported through this tool and the eQuote you’re trying to access is no longer valid. Please contact your travel professional for more details.`
    }
  }

  const isDeprecated =
    state.availablePackages &&
    state.activePackage &&
    state.availablePackages[state.activePackage] &&
    state.availablePackages[state.activePackage].brand === 'Z'

  return {
    isLoading: state.appState.isLoading || state.rfpForm.isLoading,
    hasErrors: state.appState.hasErrors || isDeprecated,
    errorStatus: state.appState.errorStatus
      ? state.appState.errorStatus
      : isDeprecated
      ? 'deprecated'
      : null,
    brandClassName: getBrandClassName(state),
    currentStep: state.appState.currentStep,
    labelsErrorDetails
  }
}

const mapDispatchToProps = dispatch => ({
  fetchQuoteDetails(id) {
    dispatch(fetchQuoteDetails(id))
  },
  fetchBrandDetails() {
    dispatch(fetchBrandDetails())
  },
  moveToRFPForm() {
    dispatch(updateCurrentAppStep(1))
  },
  fetchLabelsData() {
    dispatch(fetchLabelsData())
  },
  handle404() {
    dispatch(quoteDetailsError(404))
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App)
